

import React from 'react';
import '../App.css';
import sello1 from '../img/creatividad.png';
import sello2 from '../img/socioambiental.png';
import sello3 from '../img/cultural.png';

function Sellos() {
  return (
    <section id="sellos" className="sellos-section">
      <h2 className="sellos-title">Sellos</h2>
      <p className="sellos-title">Nuestros Sellos son...</p>

      <div className="sellos-container">
        <div className="sello-card red">
          <h1>Identidad y Creatividad</h1>
          <img src={sello1} alt="Sello 1" className="icon" />
          <p>
            Reconocemos la diversidad de intereses de nuestros estudiantes, razón por la cual hemos sintetizado las expresiones artísticas,
            deportivas y habilidades lingüísticas para dar cuenta de un proceso formativo de desarrollo personal y social. Abordamos
            la identidad como una construcción de sentido, proceso continuo que configura al sujeto como ser autónomo o heterónomo,
            que pone de relieve sus referentes sociales, culturales y geográficos, dando a conocer el modo en que el sujeto se coloca frente
            al mundo o toma lugar en él. Al mismo tiempo, consideramos la creatividad como una destreza necesaria de fortalecer, mediante
            experiencias pedagógicas que desarrollen en las y los estudiantes capacidades para adaptarse a nuevas situaciones y dar múltiples
            soluciones a los problemas. Este sello implica que cada individuo, en relación con otros, pueda responsabilizarse de sí mismo
            y realizar su proyecto personal.
          </p>
        </div>

        <div className="sello-card blue">
          <h1>Conciencia Socioambiental</h1>
          <img src={sello2} alt="Sello 2" className="icon" />
          <p>
            Promovemos la conciencia y reflexión sobre el cuidado medioambiental generando hábitos y conductas sustentables, valorando
            y respetando el entorno. Pero al mismo tiempo formamos para comprender que los problemas socioambientales están afectando
            los modos, los estilos y la calidad de vida, por lo cual se debe educar desde las experiencias próximas a su ambiente y
            trabajar por la defensa del territorio cercano. Para nuestra escuela, una conciencia socioambiental es una conciencia territorial,
            la cual busca articular a la ciudadanía en nuevas formas de participación.
          </p>
        </div>

        <div className="sello-card red">
          <h1>Interculturalidad</h1>
          <img src={sello3} alt="Sello 3" className="icon" />
          <p>
            Nuestra escuela, busca construir una cultura que da valor a la riqueza de la diversidad de toda la comunidad, por
            medio de una convivencia respetuosa entre las personas y las comunidades. Se promoverá formativamente
            estrategias que den respuesta a las necesidades que presentan los diferentes contextos sociales de las personas,
            en base al diálogo, sin prejuicios ni exclusiones. Reconocemos a la escuela como un espacio de interacción cultural,
            la cual vive permanentemente procesos de relación y mediación, en condiciones de respeto, legitimidad, simetría,
            equidad e igualdad. Mineduc, cita la interculturalidad como “el espacio en que se favorece la creación de nuevas
            formas de convivencia ciudadana entre todas y todos, sin distinción de nacionalidad u origen, que enriquece las
            construcciones del mundo, asegurando el ejercicio de los derechos individuales y colectivos”
          </p>
        </div>
      </div>

      <style jsx>{`
        .sellos-section {
          padding: 50px 20px;
          background: url('/img/fondo_sellos.jpg') no-repeat center/cover; /* opcional */
        }

        .sellos-title {
          font-size: 2rem;
          color: #fff;
          text-align: center;
          background: rgba(0,0,0,0.4);
          padding: 12px 25px;
          border-radius: 15px;
          backdrop-filter: blur(6px);
          text-shadow: 1px 1px 3px rgba(0,0,0,0.7);
          margin-bottom: 20px;
        }

        .sellos-intro {
          text-align: center;
          color: #fff;
          margin-bottom: 40px;
        }

        .sellos-container {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: center;
        }

        .sello-card {
          background: rgba(0,0,0,0.35);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border-radius: 16px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.35);
          padding: 25px;
          width: 350px; /* 🔹 ancho aumentado */
          text-align: center;
          color: #fff;
          transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.3s ease, color 0.3s ease;
        }

        .sello-card h1 {
          font-size: 1.9rem; /* 🔹 título más grande */
          margin-bottom: 15px;
        }

        .sello-card .icon {
          width: 100px;
          height: auto;
          margin-bottom: 15px;
        }

        .sello-card p {
          font-size: 1.25rem; /* 🔹 contenido aún más grande */
          line-height: 1.8;
          transition: color 0.3s ease;
        }

        /* Colores */
        .sello-card.blue {
          background: rgba(3, 49, 140, 0.45);
        }
        .sello-card.red {
          background: rgba(242, 5, 25, 0.45);
        }

        /* Hover elegante */
        .sello-card:hover {
          transform: scale(1.03);
          background: rgba(255, 255, 255, 0.15);
        }

        .sello-card:hover h1 {
          color: #ffcc00;
        }

        .sello-card:hover p {
          color: #222; /* párrafo legible al hacer hover */
        }

        @media (max-width: 960px) {
          .sello-card {
            width: 90%;
          }
        }
      `}</style>
    </section>
  );
}

export default Sellos;
